(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-story"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (event) {
  var btn = event.target.closest('[data-op-tab-btn]');
  if (!btn) return;
  var root = btn.closest('[data-op-tabs]');
  if (!root) return;

  var name = btn.getAttribute('data-op-tab-btn');

  root.querySelectorAll('[data-op-tab-btn]').forEach(function (b) {
    var on = b === btn;
    b.classList.toggle('is-active', on);
    b.setAttribute('aria-selected', on ? 'true' : 'false');
  });

  root.querySelectorAll('[data-op-panel]').forEach(function (panel) {
    var on = panel.getAttribute('data-op-panel') === name;
    panel.classList.toggle('is-active', on);
    panel.hidden = !on;
  });
});

  } catch(e) { console.error(e); }
})();
})();
